module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-oak.json
// module id = 412
// module chunks = 277561393992458